import '../../public/aws-sdk.min';
import { CoursewareServer } from '@/api/list/coursewareLibrary';

interface UnicloudUploadOptions {
  file: File | { raw: File };       // 文件对象（支持 TDesign Upload 格式）
  bucket?: string;                  // 存储桶名称（默认 'esclass-community'）
  onProgress?: (percent: number) => void;  // 上传进度回调
  type?: string;
  ACL?: string;
}

export const uploadFileToUnicloud = async (options: UnicloudUploadOptions) => {
  const { file, bucket, onProgress, type, ACL } = options;
  try {
    // 1. 获取临时凭证
    const tokenRes = await CoursewareServer.getToken();
    if (tokenRes.code !== 200) throw new Error('获取Token失败');
    // 2. 配置AWS SDK（指向紫光云）
    AWS.config.update({
      endpoint: 'https://bucket-ce4f.sichuan-2.zos.ctyun.cn',
      region: '2cdd393e876f11ea98880242ac110002',
      accessKeyId: tokenRes.data.accessKeyId,
      secretAccessKey: tokenRes.data.secretAccessKey,
      sessionToken: tokenRes.data.sessionToken,
      s3ForcePathStyle: true,
    });
    const s3 = new AWS.S3();
    // 3. 处理文件对象
    const uploadFile = 'raw' in file ? file.raw : file;
    const uuid = GetUUID();
    const fileExt = uploadFile.name.split('.').pop(); // 获取后缀
    const uniqueFileName = `${uuid}.${fileExt}`; // 组合新文件名
    const params = {
      Bucket: bucket,
      Key: uniqueFileName,
      Body: uploadFile,
      ContentType: uploadFile.type || 'application/octet-stream',
      ACL: ACL
    };
    // 4. 使用 putObject上传
    await s3.putObject(params).promise();
    // 5. 返回标准URL
    return {
      success: true,
      // ACL:'public-read'是除了视频以外的资源（图片、文件）使用的
      url: ACL ? `https://zgycdn.esclass.cn/esclass-community/${uniqueFileName}` : `https://zgycdn.esclass.cn/esclass-community/${uniqueFileName}`,
      fileName: uniqueFileName,
      originalName: uploadFile.name,
      // url: ACL ? `https://esclass-community.oss-cn-north-2.unicloudsrv.com/${uploadFile.name}` : `https://zgycdn.esclass.cn/${uploadFile.name}`,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};
